import Base from './base'

export default class CustomFields extends Base {
  list() {
    return this.apiClient.get('/custom-fields')
  }

  create(data: object) {
    return this.apiClient.post('/custom-fields', data)
  }

  update(id: string, data: object) {
    return this.apiClient.put(`/custom-fields/${id}`, data)
  }

  delete(id: string) {
    return this.apiClient.delete(`/custom-fields/${id}`)
  }

  setTaskValue(taskId: string, data: object) {
    return this.apiClient.put(`/tasks/${taskId}/custom-field-values`, data)
  }

  setTasksValue(customFieldDefinitionId: string, data: object) {
    return this.apiClient.put(`/custom-fields/${customFieldDefinitionId}/task-values`, data)
  }

  addTaskPullRequest(taskId: string, url: string) {
    return this.apiClient.post(`/tasks/${taskId}/pull-requests`, { url })
  }

  removeTaskPullRequest(taskId: string, pullRequestId: string) {
    return this.apiClient.delete(`/tasks/${taskId}/pull-requests/${pullRequestId}`)
  }
}
